class OaklenFreeDesignBanner extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.dialog = this.querySelector('[data-oaklen-free-design-dialog]');
    this.openButtons = this.querySelectorAll('[data-oaklen-free-design-open]');
    this.closeButtons = this.querySelectorAll(
      '[data-oaklen-free-design-close]',
    );
    this.handleDialogClick = this.handleDialogClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);

    this.openButtons.forEach((button) =>
      button.addEventListener('click', () => this.openDialog()),
    );
    this.closeButtons.forEach((button) =>
      button.addEventListener('click', () => this.closeDialog()),
    );
    this.dialog?.addEventListener('click', this.handleDialogClick);
    this.dialog?.addEventListener('cancel', this.handleDialogClose);
    this.dialog?.addEventListener('close', this.handleDialogClose);

    if (this.querySelector('[data-oaklen-free-design-auto-open]')) {
      this.openDialog();
    }
  }

  disconnectedCallback() {
    this.dialog?.removeEventListener('click', this.handleDialogClick);
    this.dialog?.removeEventListener('cancel', this.handleDialogClose);
    this.dialog?.removeEventListener('close', this.handleDialogClose);
    document.documentElement.classList.remove('oaklen-free-design-dialog-open');
  }

  openDialog() {
    if (!this.dialog || this.dialog.open) return;

    this.dialog.showModal();
    document.documentElement.classList.add('oaklen-free-design-dialog-open');
  }

  closeDialog() {
    if (!this.dialog?.open) return;

    this.dialog.close();
  }

  handleDialogClick(event) {
    if (event.target === this.dialog) {
      this.closeDialog();
    }
  }

  handleDialogClose() {
    document.documentElement.classList.remove('oaklen-free-design-dialog-open');
  }
}

if (!customElements.get('oaklen-free-design-banner')) {
  customElements.define('oaklen-free-design-banner', OaklenFreeDesignBanner);
}
